<div
  role="progressbar"
  [attr.aria-valuenow]="percentage"
  aria-valuemin="0"
  aria-valuemax="100"
  [style.width]="size + 'px'"
  [style.height]="size + 'px'">
  <svg
    class="progress-circle"
    aria-hidden="true"
    [attr.height]="size"
    [attr.width]="size"
    [attr.viewBox]="'0 0 ' + size + ' ' + size"
    xmlns="http://www.w3.org/2000/svg">
    <circle
      class="progress-circle-base"
      [attr.r]="radius"
      [attr.cx]="apothem"
      [attr.cy]="apothem"
    />
    <circle
      class="progress-circle-percentage"
      [attr.r]="radius"
      [attr.cx]="apothem"
      [attr.cy]="apothem"
      [style.stroke-dasharray]="circumference"
      [style.stroke-dashoffset]="dashoffset"
    />
    <text
      class="progress-circle-text"
      [attr.x]="apothem"
      [attr.y]="apothem"
      dy=".4em"
      text-anchor="middle">
      {{ percentage + '%' }}
    </text>
  </svg>
</div>
